import React from "react";
import { connect } from "react-redux";
import { SocialIcons } from "../../molecules/social-icons";
import get from "lodash/get";
import PT from "prop-types";
import "./footer.m.css";

function FooterBase(props) {
  return (
    <footer styleName="footer">
      <div className="container">
        <div styleName="container">
          <ul styleName="menu-items">
            {props.menu.map((item, index) => {
              return (
                <li key={index} styleName="menu-items-list">
                  <a href={item.completeUrl}>{item.title}</a>
                </li>
              );
            })}
          </ul>

          {!props.domainSlug ? (
            <div styleName="social-links">
              <p>Connect with us</p>
              <SocialIcons socialLinks={props.socialLinks} />
              <SocialIcons showPodcast showTelegram showLinkedin showSpotify />
              <SocialIcons showCastBox showDiscord showRss />
            </div>
          ) : (
            <div styleName="social-links">
              <p>हमसे जुड़ें </p>
              <SocialIcons socialLinks={props.socialLinks} />
              <SocialIcons showDiscord showNewsletter showRSS />
            </div>
          )}
          <div styleName="about">
            {!props.domainSlug ? (
              <p>
                With your support, <br />
                we can do more ground-reports.
              </p>
            ) : (
              <p>
                आपका सहयोग हमें ज्यादा से <br />
                ज्यादा ग्राउंड रिपोर्ट करने की ताकत देता है
              </p>
            )}
            {!props.domainSlug ? (
              <a styleName="nl-btn" href="/sena">
                Join NL Sena
              </a>
            ) : (
              <a styleName="nl-btn" href={`/subscription?ref=footer-hindi`}>
                सब्सक्राइब करें
              </a>
            )}
          </div>
          <div styleName="copyright">
            <p styleName="copyright-text">
              © Newslaundry Media Private Limited. All Rights Reserved.
            </p>
            <a href="https://www.quintype.com">
              <p styleName="copyright-text">Powered by Quintype</p>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}

FooterBase.propTypes = {
  menu: PT.arrayOf(
    PT.shape({
      completeUrl: PT.string,
      title: PT.string
    })
  ),
  socialLinks: PT.object
};

function mapStateToProps(state) {
  const menu =
    get(state, ["qt", "data", "navigationMenu", "footerLinks"], []) ||
    get(state, ["qt", "data", "navigationMenu", "default"], []);
  return {
    menu: menu,
    socialLinks: get(state, ["qt", "config", "social-links"], []),
    domainSlug: get(state, ["qt", "domainSlug"], null),
    frontEndUrl: get(state, ["qt", "config", "publisher", "frontend_url"], "")
  };
}

export const Footer = connect(mapStateToProps)(FooterBase);
